module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/invite_male_12c377.gif";